var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-16-/-Discovery-+-Sharing-/-download_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-download-solid-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375,12.1875 L0.9375,14.0625 L14.0625,14.0625 L14.0625,12.1875 L0.9375,12.1875 Z M11.25,6.5625 L10.3125,5.625 L8.4375,7.5 L8.4375,0.9375 L6.5625,0.9375 L6.5625,7.5 L4.6875,5.625 L3.75,6.5625 L7.5,10.425 L11.25,6.5625 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.09c186cad3517a59d123c013aaf97bb1.svg";
export { ForwardRef as ReactComponent };